/* eslint-disable vue/html-indent */
<template>
  <v-container fluid class="resigter-module pa-0 fill-height auth-signup white">
    <v-row no-gutters class="align-center justify-center fill-height">
      <v-col cols="12" md="6" class="fill-height white--text justify-center">
        <v-img
          src="https://images.unsplash.com/photo-1541364208048-4d227de804a4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=975&q=80"
          class="align-center fill-height auth-signup__info"
          aspect-ratio="1"
        >
          <router-link
            :to="{ name: 'auth' }"
            class="auth-signup__brand white--text font-weight-bold"
          >
            oceaneye
          </router-link>
          <div class="auth-signup__card">
            <h2
              class="display-2 font-weight-bold mb-12 display-2"
              style="color: white"
            >
              Sign up to participate in the global fight to preserve wildlife
            </h2>
            <div class="d-flex justify-space-between">
              <v-btn
                depressed
                class="font-weight-bold px-4 px-lg-8 btn-text-primary"
                large
                color="white"
                min-width="45%"
              >
                Tutorial
                <v-icon class="ml-1 ml-lg-5">$arrowRight</v-icon>
              </v-btn>
              <v-btn
                depressed
                class="font-weight-bold px-lg-8 title border-3"
                outlined
                large
                color="white"
                min-width="45%"
              >
                Learn more
                <v-icon class="ml-1 ml-lg-5">$arrowRight</v-icon>
              </v-btn>
            </div>
          </div>
        </v-img>
      </v-col>
      <v-col cols="12" md="6" class="white">
        <ValidationObserver ref="validator" @handle="handleValidation">
          <v-form @submit.prevent="submit()">
            <transition name="fade">
              <keep-alive>
                <component
                  :is="
                    step === 1
                      ? 'step-1'
                      : request.is_tourist
                      ? 'Tourist'
                      : 'Operator'
                  "
                  :request="request"
                  :key="
                    `${step} ${
                      step === 2
                        ? request.is_tourist
                          ? '-tourist'
                          : '-operator'
                        : ''
                    }`
                  "
                  @step="walk"
                  @submit="submit"
                />
              </keep-alive>
            </transition>
          </v-form>
        </ValidationObserver>

        <v-row class="my-4 align-center grey--text lighten-3 mx-md-480 ma-auto">
          <v-divider />
          <span class="pa-1">OR</span>
          <v-divider />
        </v-row>
        <v-row class="justify-center px-24 mb-24 pb-10 mb-mb-0">
          <router-link :to="{ name: 'login' }" class="title link-default">
            Login
          </router-link>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegistrationRequest from '@request/Auth/RegistrationRequest';

export default {
  name: 'Register',
  metaInfo: {
    titleTemplate: '%s - Register',
  },
  components: {
    Step1: () => import('@pages/auth/_partials/Step1'),
    Operator: () => import('@pages/auth/_partials/OperatorRegistration'),
    Tourist: () => import('@pages/auth/_partials/TouristRegistration'),
  },
  data() {
    return {
      step: 1,
      request: new RegistrationRequest(this.$refs.validator),
    };
  },
  watch: {
    step(step) {
      if (step < 1) {
        this.step = 1;
      } else if (step > 2) {
        this.step = 2;
      }
    },
  },
  methods: {
    async submit() {
      if (await this.$refs.validator.validate()) {
        await this.request.submit();
      }
    },
    walk(step) {
      this.step += step;
    },
    handleValidation() {
      //
    },
  },
  mounted() {
    this.request.$validator = this.$refs.validator;
  },
};
</script>
